import { Avatar, TableRow, TableCell, Typography, ListItemText } from '@mui/material';

import Label from 'src/components/label';
import { TransactionStatus } from 'src/type/transaction';
import { shortString } from 'src/utils/format-string';

import { fDate, fTime } from 'src/utils/format-time';
import { ReportType } from 'src/type/report';
import { txStatusLabel } from '../__gold-withdraw/utils';
import { txAction } from './utils';

type Props = {
  row: ReportType;
};

export default function ReportTableRow({ row }: Props) {
  const { user, createdAt, type, status, updatedAt } = row;
  return (
    <TableRow>
      <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar alt="" sx={{ mr: 2 }}>
          {user?.firstName?.[0].toUpperCase()}
        </Avatar>

        <ListItemText
          disableTypography
          primary={
            <Typography variant="body2" noWrap>
              {user?.firstName} {user?.lastName}
            </Typography>
          }
          secondary={
            <Typography variant="caption" color="text.secondary" noWrap>
              #{shortString(user?.uid)}
            </Typography>
          }
        />
      </TableCell>

      <TableCell>{txAction(type)}</TableCell>

      <TableCell>
        <ListItemText
          primary={fDate(createdAt, 'DD MMMM BBBB')}
          secondary={fTime(createdAt)}
          primaryTypographyProps={{ typography: 'body2', noWrap: true }}
          secondaryTypographyProps={{
            mt: 0.5,
            component: 'span',
            typography: 'caption',
          }}
        />
      </TableCell>

      <TableCell>
        {status === TransactionStatus.SUCCESS ? (
          <ListItemText
            primary={fDate(updatedAt, 'DD MMMM BBBB')}
            secondary={fTime(updatedAt)}
            primaryTypographyProps={{ typography: 'body2', noWrap: true }}
            secondaryTypographyProps={{
              mt: 0.5,
              component: 'span',
              typography: 'caption',
            }}
          />
        ) : (
          '-'
        )}
      </TableCell>

      {/* <TableCell>{fNumber(creditAmount || 0)}</TableCell> */}

      <TableCell>
        <Label
          variant="soft"
          color={
            (status === TransactionStatus.SUCCESS && 'success') ||
            (status === TransactionStatus.PENDING && 'warning') ||
            (status === TransactionStatus.REJECTED && 'error') ||
            (status === TransactionStatus.CANCEL && 'info') ||
            (status === TransactionStatus.FAILED && 'default') ||
            (status === TransactionStatus.WAITING && 'info') ||
            (status === TransactionStatus.WAITING_PAYMENT && 'default') ||
            (status === TransactionStatus.WAITING_TICKET && 'secondary') ||
            'default'
          }
        >
          {txStatusLabel(status!)}
        </Label>
      </TableCell>
    </TableRow>
  );
}
